import { NgModule } from '@angular/core';
import { NgClinicalChartingStoreModule } from '@principle-theorem/ng-clinical-charting/store';
import { PipesModule } from '@principle-theorem/ng-shared';
import { ChartDialogService } from './chart-dialog.service';
import { ChartedRefLabelPipe } from './charted-ref-label.pipe';
import { ComponentsModule } from './components/components.module';
import { TreatmentProviderService } from './treatment-provider.service';
import { ServiceCodeManagerService } from './services/service-code-manager.service';

@NgModule({
  imports: [
    PipesModule,
    ComponentsModule,
    NgClinicalChartingStoreModule,
  ],
  declarations: [ChartedRefLabelPipe],
  providers: [
    ChartDialogService,
    TreatmentProviderService,
    ServiceCodeManagerService,
  ],
  exports: [ComponentsModule, NgClinicalChartingStoreModule],
})
export class NgClinicalChartingModule {}
